module.exports = ":host {\n  font-weight: 300;\n  text-align: center; }\n  :host img {\n    opacity: 0.4;\n    height: 200px; }\n"